export const REVIEWER_STATUSES = {
  ACTIVE: 'in_pool',
  INACTIVE: 'inactive',
  REJECTED: 'not_ready',
};

export const INTEREST_LIMIT = 3;
